import Icon from "@mdi/react";
import { mdiPrinter, mdiClipboardMultipleOutline } from "@mdi/js";
import "../../../assets/styles/admin/booking.scss";
import MainButton from "../../../components/button/mainButton";
import { useState } from "react";
import BookingDetail from "./bookingdetail";
import WorkCalendar from "./workcalendar";

const WorkSchedule = () => {
  const [active, setActive] = useState(1);
  const [state, setState] = useState<any>({ data: [], copied: false });

  const tabList = [{ title: "วันนี้/Today", value : 'resourceTimeGridDay' }, { title: "เดือน/Month", value : 'dayGridMonth' }];
  const panelList = [{ panel: <BookingDetail /> }, { panel: <WorkCalendar /> }];

  const changeTab = (index: number) => {
    setActive(index);
  };

  return (
    <div style={{ padding: "0px 40px" }}>
      <div className="create-page" style={{ padding: "0px 10px" }}>
        <div className="row">
          <div className="slect-booking">
            <div className="booking-datePicker">
              {/* <DatePicker size={`middle`} bordered={false} /> */}
            </div>
            <div className="booking-btnPrint">
              <div className={`booking-tabs`}>
                {tabList?.map((child, index) => {
                  return (
                    <div
                      className={`booking-tabs-container ${
                        active == index ? "booking-active" : ""
                      } `}
                      key={index}
                      onClick={() => changeTab(index)}
                    >
                      {child.title}
                    </div>
                  );
                })}
              </div>
              <MainButton title="Print" width="90px" className="mg-10">
                <Icon path={mdiPrinter} size="20" color="#FFFFFF" />
              </MainButton>
            </div>
          </div>
        </div>
        <div> <WorkCalendar initialView={tabList[active]}/></div>
        {/* <div>{panelList[Number(active)].panel}</div> */}
      </div>
    </div>
  );
};
export default WorkSchedule;
